<template>
  <div id="cesiumContainer"></div>
</template>
<script>
var _viewer = {};
var locationBuilding;
var buildingentities;
export default {
  props:["roletype"],
  name: "cesiumContainer",
  data(){
    return {
      
    }
  },
  mounted() {
    //解决因为cesium生成太快，导致页面无法渲染的问题
    setTimeout(this.initCesium, 1000);
  },
  // props:["roletype"],
  methods: {
    /**初始化实例对象 */
    initCesium() {
      _viewer = new Cesium.Viewer("cesiumContainer", {
        shadows: false,
        animation: false,
        shouldAnimate: true,
        homeButton: false,
        fullscreenButton: false,
        baseLayerPicker: false,
        geocoder: false,
        timeline: false,
        sceneModePicker: false,
        navigationHelpButton: false,
        infoBox: true,
        requestRenderMode: true,
        scene3DOnly: true
      });
      _viewer._cesiumWidget._creditContainer.style.display = "none";
      var tileseturl;
      // { id:"GRID.9",name: "明珠苑三组", coor: [117.99855, 32.78291] },
      // { id:"GRID.8",name: "明珠苑一组", coor: [118.0015, 32.7845] },
      // { id:"GRID.7",name: "明珠苑二组", coor: [118.002, 32.7823] },
      // { id:"GRID.6",name: "慧景组", coor: [118.003, 32.779] },
      // { id:"GRID.5",name: "明珠苑五组", coor: [118.001, 32.78] },
      // { id:"GRID.4",name: "农苑组", coor: [117.999, 32.78] },
      // { id:"GRID.3",name: "明珠苑四组", coor: [117.997, 32.779] },
      // { id:"GRID.2",name: "花园一组", coor: [117.995, 32.778] },
      // { id:"GRID.1",name: "花园二组", coor: [117.993, 32.779] }
      switch (this.roletype) {
        case "all":
          tileseturl = "http://36.33.216.70:8086/tile/tileset.json";
          break;
        case "GRID.6":
          tileseturl = "http://36.33.216.70:8090/mgtiles/hjz/tileset.json";
          break;
        case "GRID.1":
          tileseturl = "http://36.33.216.70:8090/mgtiles/hyez/tileset.json";
          break;
        case "GRID.2":
          tileseturl = "http://36.33.216.70:8090/mgtiles/hyyz/tileset.json";
          break;
        case "GRID.9":
          tileseturl = "http://36.33.216.70:8090/mgtiles/mzySanz/tileset.json";
          break;
        case "GRID.3":
          tileseturl = "http://36.33.216.70:8090/mgtiles/mzySiz/tileset.json";
          break;
        case "GRID.7":
          tileseturl = "http://36.33.216.70:8090/mgtiles/mzyez/tileset.json";
          break;
        case "GRID.5":
          tileseturl = "http://36.33.216.70:8090/mgtiles/mzywz/tileset.json";
          break;
        case "GRID.8":
          tileseturl = "http://36.33.216.70:8090/mgtiles/mzyyz/tileset.json";
          break;
        case "GRID.4":
          tileseturl = "http://36.33.216.70:8090/mgtiles/nyz/tileset.json";
          break;
      }
      var tileset = _viewer.scene.primitives.add(
        new Cesium.Cesium3DTileset({
          url: tileseturl,
          show: false,
          maximumScreenSpaceError: 22,
          maximumNumberOfLoadedTiles: 100000,
          baseScreenSpaceError: 1024,
          skipScreenSpaceErrorFactor: 16
        })
      );
      tileset.readyPromise
        .then(tileset => {
          _viewer.zoomTo(
            tileset,
            new Cesium.HeadingPitchRange(
              0.5,
              -0.9,
              tileset.boundingSphere.radius * 1.73
            )
          );
          tileset.show = true;
          var boundingSphere = tileset.boundingSphere;
          var cartographic = Cesium.Cartographic.fromCartesian(
            boundingSphere.center
          );
          var surface = Cesium.Cartesian3.fromRadians(
            cartographic.longitude,
            cartographic.latitude,
            0.0
          );
          var offset = Cesium.Cartesian3.fromRadians(
            cartographic.longitude,
            cartographic.latitude,
            0
          );
          var translation = Cesium.Cartesian3.subtract(
            offset,
            surface,
            new Cesium.Cartesian3()
          );
          tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
        })
        .otherwise(function(error) {
          console.log(error);
        });
      // this.$nextTick(() => {
      //
      // })
      this.loadGrid(this.roletype);
      this.loadBuilding();
      this.addLEFT_CLICK();
      this.loadBuildingjson();
      this.$Bus.$on("userLocation", data => {
        // this.drawer = data;
        // console.log(data);
        let id = data.split("buildclick");
        console.log(id[1]);
        this.openGrid();
        this.locationBuilding(id[1]);
      });
    },
    loadGrid(roletype) {
      var promise = Cesium.GeoJsonDataSource.load("Cesium/data/grid.geojson");
      promise.then(dataSource => {
        _viewer.dataSources.add(dataSource);
        var entities = dataSource.entities.values;
        var color = Cesium.Color.AQUA;
        for (var i = 0; i < entities.length; i++) {
          var entity = entities[i];
          roletype == "all"?entity.show = true:entity.show = false;
          switch (entity.id) {
            case "GRID.1":
              roletype == entity.id?entity.show = true:1;
              color = Cesium.Color.AQUA;
              break;
            case "GRID.2":
              roletype ==entity.id?entity.show = true:1;
              color = Cesium.Color.CHOCOLATE;
              break;
            case "GRID.3":
              roletype ==entity.id?entity.show = true:1;
              color = Cesium.Color.DARKCYAN;
              break;
            case "GRID.4":
              roletype ==entity.id?entity.show = true:1;
              color = Cesium.Color.CHARTREUSE;
              break;
            case "GRID.5":
              roletype ==entity.id?entity.show = true:1;
              color = Cesium.Color.DARKORANGE;
              break;
            case "GRID.6":
              roletype ==entity.id?entity.show = true:1;
              color = Cesium.Color.CRIMSON;
              break;
            case "GRID.7":
              roletype ==entity.id?entity.show = true:1;
              color = Cesium.Color.LIMEGREEN;
              break;
            case "GRID.8":
              roletype ==entity.id?entity.show = true:1;
              color = Cesium.Color.BROWN;
              break;
            case "GRID.9":
              roletype ==entity.id?entity.show = true:1;
              color = Cesium.Color.GOLD;
              break;
          }
          entity.name = "grid";
          entity.polygon.material = color;
          entity.polygon.outline = true;
          entity.polygon.height = 30;
        }
        var namedta = [
          { id:"GRID.9",name: "明珠苑三组", coor: [117.99855, 32.78291] },
          { id:"GRID.8",name: "明珠苑一组", coor: [118.0015, 32.7845] },
          { id:"GRID.7",name: "明珠苑二组", coor: [118.002, 32.7823] },
          { id:"GRID.6",name: "慧景组", coor: [118.003, 32.779] },
          { id:"GRID.5",name: "明珠苑五组", coor: [118.001, 32.78] },
          { id:"GRID.4",name: "农苑组", coor: [117.999, 32.78] },
          { id:"GRID.3",name: "明珠苑四组", coor: [117.997, 32.779] },
          { id:"GRID.2",name: "花园一组", coor: [117.995, 32.778] },
          { id:"GRID.1",name: "花园二组", coor: [117.993, 32.779] }
        ];
        for (var i = 0; i < namedta.length; i++) {
          if(roletype == namedta[i].id || roletype == "all"){
          _viewer.entities.add({
            id:namedta[i].id,
            name: "lebal",
            position: Cesium.Cartesian3.fromDegrees(
              namedta[i].coor[0],
              namedta[i].coor[1],
              50
            ),
            point: {
              pixelSize: 5,
              color: Cesium.Color.RED,
              outlineColor: Cesium.Color.YELLOW,
              outlineWidth: 2
            },
            label: {
              text: namedta[i].name,
              font: "12.5pt MicroSoft YaHei",
              // style: Cesium.LabelStyle.FILL_AND_OUTLINE,
              outlineWidth: 2,
              color: Cesium.Color.fromCssColorString("#16ff28"),
              showBackground: true,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              pixelOffset: new Cesium.Cartesian2(0, -9)
            }
          });
          }
        }
        // 鼠标滚轮事件
        var camera = _viewer.camera;
        var handler = new Cesium.ScreenSpaceEventHandler(_viewer.scene.canvas);
        var entitygrid = _viewer.entities.values;
        var entitygridpo = dataSource.entities.values;
        handler.setInputAction(function(wheelment) {
          var height = camera.positionCartographic.height;
          if (height > 900) {
            for (var i = 0; i < entitygrid.length; i++) {
              if(roletype =="all"){entitygrid[i].name == "lebal"?entitygrid[i].show = true:1};
              if(roletype == entitygrid[i].id){entitygrid[i].show = true}
            }
            for (var i = 0; i < entitygridpo.length; i++) {
              if(roletype =="all"){entitygridpo[i].name == "grid"?entitygridpo[i].show = true:1;}
              if(roletype == entitygridpo[i].id){entitygridpo[i].show = true}
            }
          }
          if (height < 900) {
            for (var i = 0; i < entitygrid.length; i++) {
              entitygrid[i].name == "lebal" ? (entitygrid[i].show = false) : 1;
            }
            for (var i = 0; i < entitygridpo.length; i++) {
              entitygridpo[i].name == "grid"
                ? (entitygridpo[i].show = false)
                : 1;
            }
          }
        }, Cesium.ScreenSpaceEventType.WHEEL);
      });
      _viewer.scene.postProcessStages.fxaa.enabled = false; //去锯齿
    },
    loadBuilding() {
      //楼栋底面数据
      var classifytileset = new Cesium.Cesium3DTileset({
        url: "Cesium/data/mgbuildingtile/tileset.json",
        classificationType: Cesium.ClassificationType.CESIUM_3D_TILE
      });
      classifytileset.style = new Cesium.Cesium3DTileStyle({
        color: "rgba(255, 0, 0, 0.01)"
      });
      _viewer.scene.primitives.add(classifytileset);
      var selected = {
        feature: undefined,
        originalColor: new Cesium.Color(255, 0, 0, 0.01)
      };
    },
    // 地图的点击事件
    addLEFT_CLICK() {
      var selected = {
        feature: undefined,
        originalColor: new Cesium.Color(255, 0, 0, 0.01)
      };
      _viewer.screenSpaceEventHandler.setInputAction(movement => {
        // Pick a new feature
        var pickedFeature = _viewer.scene.pick(movement.position);
        // 网格被点击时触发
        if (
          Cesium.defined(pickedFeature) &&
          pickedFeature.id &&
          pickedFeature.id.name == "grid"
        ) {
          let girdid =
            "girdclick" + pickedFeature.id._properties._网格名称._value;
          // console.log();//网格点击出口
          this.$Bus.$emit("gridClick", girdid);
          return;
        }
        // If a feature was previously selected, undo the highlight
        if (Cesium.defined(selected.feature)) {
          selected.feature.color = selected.originalColor;
          selected.feature = undefined;
        }
        // if (
        //   !Cesium.defined(pickedFeature) ||
        //   !Cesium.defined(pickedFeature.getProperty)
        // ) {
        //   return;
        // }
        if (selected.feature === pickedFeature) {
          return;
        }
        selected.feature = pickedFeature;
        console.log('pickedFeature--',pickedFeature)
        pickedFeature.color = new Cesium.Color(1, 0, 0, 0.6);
        var senddata = "buildclick" + pickedFeature.getProperty("id");
        var wgdata = pickedFeature.getProperty("grid");
        var gridId = pickedFeature.getProperty("gridid");
        this.$Bus.$emit("buildclick", senddata, wgdata, gridId);
        this.$Bus.$emit("gridClick", gridId);
        console.log('senddata--',senddata);
        console.log('wgdata--',wgdata);
        console.log('gridId--',gridId);
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    },

    /*
     格网控制显隐
     */
    openGrid(flag) {
      var entitygrid = _viewer.entities.values;
      var entitygridpo = _viewer.dataSources.getByName("grid.geojson")[0]
        .entities.values;
      if (flag) {
        for (var i = 0; i < entitygrid.length; i++) {
          entitygrid[i].name == "lebal" ? (entitygrid[i].show = true) : 1;
        }
        for (var i = 0; i < entitygridpo.length; i++) {
          entitygridpo[i].name == "grid" ? (entitygridpo[i].show = true) : 1;
        }
      }
      if (!flag) {
        for (var i = 0; i < entitygrid.length; i++) {
          entitygrid[i].name == "lebal" ? (entitygrid[i].show = false) : 1;
        }
        for (var i = 0; i < entitygridpo.length; i++) {
          entitygridpo[i].name == "grid" ? (entitygridpo[i].show = false) : 1;
        }
      }
    },
    /*
     * 加载建筑
     * */
    loadBuildingjson() {
      var options = {
        camera: _viewer.scene.camera,
        canvas: _viewer.scene.canvas,
        clampToGround: true
      };
      var promise = Cesium.GeoJsonDataSource.load(
        "Cesium/data/building.geojson",
        options
      );
      promise.then(dataSource => {
        _viewer.dataSources.add(dataSource);
        dataSource.show = true;
        buildingentities = dataSource.entities.values;
        for (var i = 0; i < buildingentities.length; i++) {
          buildingentities[i].show = false;
        }
      });
    },
    /*
      根据id定位建筑
     */
    locationBuilding(id) {
      locationBuilding !=undefined ? locationBuilding.show=false : 1;
      for (var i = 0; i < buildingentities.length; i++) {
        if (id == buildingentities[i].properties.getValue().id) {
          locationBuilding = buildingentities[i];
          buildingentities[i].show = true;
          buildingentities[i].polygon.material = new Cesium.Color(1, 0, 0, 0.8)
          var Cartesian3center = Cesium.BoundingSphere.fromPoints(
            buildingentities[i].polygon.hierarchy.getValue().positions
          ).center;
          var ellipsoid = _viewer.scene.globe.ellipsoid;
          var cartesian3 = new Cesium.Cartesian3(
            Cartesian3center.x,
            Cartesian3center.y,
            Cartesian3center.z
          );
          var cartographic = ellipsoid.cartesianToCartographic(cartesian3);
          var lat = Cesium.Math.toDegrees(cartographic.latitude);
          var lng = Cesium.Math.toDegrees(cartographic.longitude);
          var alt = cartographic.height;
          _viewer.camera.flyTo({
            destination: new Cesium.Cartesian3.fromDegrees(
              lng,
              lat - 0.001,
              alt + 128
            ),
            orientation: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-45),
              roll: 0.0
            }
          });
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#cesiumContainer {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
